"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "OzTag__Wrapper",
  componentId: "sc-1udtctc-0"
})(["\n  display: ", ";\n  ", "\n  border: 1px solid black;\n  color: #000;\n  outline: none;\n  box-shadow: none;\n  border-radius: 4px;\n  /* text-transform: uppercase; */\n  text-align: center;\n  font-weight: bold;\n  background-clip: border-box;\n  position: relative;\n  overflow: hidden;\n  text-decoration: none;\n  box-sizing: border-box;\n\n  &:active, &:focus{\n    box-shadow: none;\n    outline: none;\n    text-decoration: none;\n  }\n\n  &, & * {\n    box-sizing: border-box;\n  }\n\n  ", ";\n\n  ", ";\n"], function (props) {
  return props.display;
}, function (props) {
  return props.display === "inline" ? "z-index: 3;" : null;
}, function (props) {
  return props.size === "big" ? "\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 16px;\n    min-width: 60px;\n  " : function (props) {
    return props.size === "small" ? "\n    padding: 2px 4px 2px;\n    font-size: 10px;\n    line-height: 12px;\n    min-width: 40px;\n  " : "\n    padding: 4px 8px;\n    font-size: 11px;\n    line-height: 14px;\n    min-width: 50px;\n  ";
  };
}, function (props) {
  return props.variant === "silvertree" ? "\n    color: ".concat(_consts.SILVERTREE, ";\n    background-color: #ffffff;\n    border-color: ").concat(_consts.SILVERTREE, ";\n\n  ") : function (props) {
    return props.variant === "chetwodeblue" ? "\n    color: ".concat(_consts.CHETWODEBLUE, ";\n    background-color: #ffffff;\n    border-color: ").concat(_consts.CHETWODEBLUE, ";\n\n  ") : function (props) {
      return props.variant === "bittersweet" ? "\n    color: ".concat(_consts.BITTERSWEET, ";\n    background-color: #ffffff;\n    border-color: ").concat(_consts.BITTERSWEET, ";\n\n    ") : function (props) {
        return props.variant === "mustard" ? "\n      color: ".concat(_consts.MUSTARD, ";\n      background-color: #ffffff;\n      border-color: ").concat(_consts.MUSTARD, ";\n\n  ") : function (props) {
          return props.variant === "white" ? "\n    color: #333333;\n    background-color: #ffffff;\n    border-color: #FFFFFF;\n  " : "\n\n  ";
        };
      };
    };
  };
});

var OzTag = function OzTag(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "silvertree" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      onClick = _ref.onClick,
      children = _ref.children;
  return __jsx(Wrapper, {
    variant: variant,
    size: size,
    display: display,
    onClick: onClick
  }, children);
};

var _default = OzTag;
exports.default = _default;